import { rwd } from '@billy/design-system'
import styled from '@emotion/styled'

interface StackLayoutProps {
  direction: 'row' | 'column'
}

export const StackLayoutResponsiveWrapper = styled.div<StackLayoutProps>`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  width: 100%;

  ${({ direction }) =>
    `${rwd.equalOrLessThan('large')} {
      flex-direction: ${direction === 'column' ? 'row' : 'column'};
      }`}
`
